/**
 * FooterSlot — [T149-PR8-CONT-11] footer row (footnote + last-updated).
 *
 * Sole owner of:
 *   - `data-testid="widget-footer"` (the px-3 pb-2 pt-1 shrink-0 row)
 *   - `data-testid="widget-last-updated-${id}"` (hidden above 480px)
 *
 * The footer is OPTIONAL — when both `footer` and `lastUpdatedLabel`
 * are absent the row is not rendered at all (preserves the pre-refactor
 * "skip the row entirely" behaviour to avoid an empty flexbox gap).
 */

import type { FooterState } from './types';

export type FooterSlotProps = FooterState;

/**
 * Footer row. Returns `null` when both the custom footnote and the
 * last-updated label are absent.
 */
export function FooterSlot({ id, footer, lastUpdatedLabel }: FooterSlotProps) {
  if (footer == null && !lastUpdatedLabel) {
    return null;
  }

  return (
    <div
      data-testid="widget-footer"
      className="px-3 pb-2 pt-1 shrink-0 text-[10px] md:text-xs text-muted-foreground flex items-center justify-between gap-2"
    >
      <div className="min-w-0 flex-1">{footer}</div>
      {lastUpdatedLabel && (
        <span
          data-testid={`widget-last-updated-${id}`}
          className="hidden sm:block shrink-0 text-[10px] text-muted-foreground whitespace-nowrap"
        >
          {lastUpdatedLabel}
        </span>
      )}
    </div>
  );
}
